import Moment from 'moment';
import PdfGenerator from './PdfGenerator';

class RubricaElenco extends PdfGenerator {

    getTipoSoggettoCompatto(soggetto){
        let rv = '';
        if (soggetto.isProspect)
        {
            rv = 'P';
        }
        if (soggetto.isCliente)
        {
            rv += 'C';
        }
        if (soggetto.isFornitore)
        {
            rv += 'F';
        }
        if (soggetto.isTp)
        {
            rv += 'T';
        }
        return rv;
    }

    getNomeSoggetto(soggetto){
        let rv = '';
        if (soggetto.tit)
        {
            rv = soggetto.tit;
        }
        rv += ' ' + soggetto.nomeCompleto;
        return rv.trim();
    }

    getIndirizzoCompleto(ogg){
        let rv = '';
        rv += ogg.indirizzo ? ' ' + ogg.indirizzo: '';
        rv += ogg.cap ? ' ' + ogg.cap: '';
        rv += ogg.citta ? ' ' + ogg.citta: '';
        rv += ogg.provincia ? ' ' + ogg.provincia: '';
        rv += ogg.stato ? ' ' + ogg.stato: '';

        return rv.trim();
    }

    getCitta(ogg){
        let rv = '';
        rv += ogg.citta ? ' ' + ogg.citta: '';
        return rv.trim();
    }

    getNumeriTelefono(ogg){
        let rv = '';
        rv += ogg.telefono1 ? ' ' + ogg.telefono1: '';
        rv += ogg.telefono2 ? ' ' + ogg.telefono2: '';
        rv += ogg.cellulare ? ' ' + ogg.cellulare: '';
        return rv.trim();
    }

    getEmailPec(ogg){
        let rv = '';
        rv += ogg.email ? ' ' + ogg.email: '';
        rv += ogg.pec ? ' ' + ogg.pec: '';
        return rv.trim();
    }

    getCFPiva(ogg){
        let rv = '';
        if (ogg.piva){
            rv = ogg.piva;
        }
        else if(ogg.cfisc){
            rv = ogg.cfisc;
        }
        return rv.trim();
    }

    getCreazModif(ogg){
        let rv = '';
        rv +=  this.getCreaz(ogg);
        rv += ' - ' + this.getUltimaModifica(ogg);
        return rv;
    }
    getCreaz(ogg){
        let rv = '';
        rv += (ogg.creatoIl ? Moment(ogg.creatoIl).format('DD/MM/YY HH:mm') : '?') + ' ' +
            (ogg.creatoDa ? ogg.creatoDa.username : '?');
        return rv;
    }
    getUltimaModifica(ogg){
        let rv = '';
        rv += (ogg.modificatoIl ? Moment(ogg.modificatoIl).format('DD/MM/YY HH:mm') : '?') + ' ' +
            (ogg.modificatoDa ? ogg.modificatoDa.username : '?');
        return rv;
    }
}

export default RubricaElenco;


/** WEBPACK FOOTER **
 ** ./src/pdf/RubricaElenco.js
 **/